import { useTakeDealControlMutation } from '@/lib/graphql/generated/graphql';
import { trackEvent } from '@/lib/mixpanel';
import { dealRefetchAtom } from '@/states/deal.state';
import { useAtomValue } from 'jotai';

export function useTakeDealControl(dealId: string) {
  const dealRefetch = useAtomValue(dealRefetchAtom);
  const [takeDealControlMutation, { loading, error }] =
    useTakeDealControlMutation();

  const takeDealControl = async () => {
    const result = await takeDealControlMutation({
      variables: { dealId },
    });

    const response = result.data?.takeDealControl;
    if (response?.__typename === 'DomainException') {
      throw new Error(response.code);
    }

    await dealRefetch.fn();
    trackEvent('DEAL_CONTROL_TAKEN', { dealId });
    return result;
  };

  return {
    takeDealControl,
    loading,
    error,
  };
}
